import React from 'react'
import BasicsList from './../components/Basics/BasicsList'
import Slider from './../components/Slider'
import ClientsCases from './../components/ClientsCases'

class Home extends React.Component {

  render() {
    return <div>
      <Slider />
      <ClientsCases origin="home" />
      <BasicsList />
    </div>
  }
}

export default Home




// WEBPACK FOOTER //
// ./src/containers/Home.jsx